import { render, staticRenderFns } from "./ResourceLibrarySideMenu.vue?vue&type=template&id=6649a789&scoped=true"
import script from "./ResourceLibrarySideMenu.vue?vue&type=script&lang=js"
export * from "./ResourceLibrarySideMenu.vue?vue&type=script&lang=js"
import style0 from "./ResourceLibrarySideMenu.vue?vue&type=style&index=0&id=6649a789&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6649a789",
  null
  
)

export default component.exports